module.exports = __webpack_public_path__ + "img/kh.a3798580.png";